// This file contains compile-time defined variables.

export const NAME: string = "@shockpkg/ria-packager";

export const VERSION: string = "1.5.1";
